module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc15-e6919ed55d6524ebc53e7313b7ecf6c1.jpg";